/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { camelCase, cloneDeep, uniqueId } from 'lodash';

import { limitsHandler } from '../../limits/index';

function handleInitialAdjustments({
  questionnaire
}) {
  return questionnaire.map(question => {

    if (question.idQuestion === 1736) {
      question.visibleQuestion = false;
      if (!questionnaire.find(qst => qst.answer === question.answer && qst?.mainGroup))
        question.mainGroup = true;
    }

    if (question.idQuestion === 1689) {
      question.visibleQuestion = false;
    }

    if (question.idQuestion === 1736 && question.answer === "Judicial" && question?.childrenQuestions?.length) {
      const questionModality = question.childrenQuestions.find(qst => qst.idQuestion === 1689);

      if (questionModality?.answer?.includes("Judicial Depósito Recursal")) {
        question.childrenQuestions.map(qst => {
          if (qst.idQuestion === 1691) qst.disabled = true;
          return qst;
        });
      }
    }

    if (question.idQuestion === 1736 && question.answer === "Adicional" && question?.childrenQuestions?.length) {
      const questionModality = question.childrenQuestions.find(qst => qst.idQuestion === 1689);

      if (questionModality?.answer?.includes("Cobertura Adicional – Despesas de contenção e salvamento")) {
        question.visibleQuestion = false;
        question.hideModality = true;
        questionModality.visibleQuestion = false;
        questionModality.hideModality = true;
        
        question.childrenQuestions.map(qst => {
          qst.visibleQuestion = false;
          qst.hideModality = true;
          return qst;
        });
      }
    }

    return question;
  })
}

function handleModalities({
  questionnaire,
  modalitiesFeesData,
  scoreInformationData,
  modalities,
  setModalities,
  setFieldValue,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  limitValueOverwrite,
  setOutOfRangeError
}) {
  try {
    const getScoreFeeByModality = (scoreInformationData, score, modality) => {
      try {
      const modalitiesHeaders = scoreInformationData[0].rateModalityHeader || [];

      const modalityIndex = modalitiesHeaders.findIndex(modalityHeader => (modalityHeader.toLowerCase().trim() === modality.toLowerCase().trim())) ?? -1;

      const scoreInformation = scoreInformationData.find(scoreInfo => scoreInfo.score == score) || {};

      if (scoreInformation && scoreInformation?.rateList[modalityIndex]) return (Number(scoreInformation.rateList[modalityIndex].toFixed(4)) * 100).toFixed(4);

      return 0;
      } catch (e) {
        console.log('getScoreFeeByModality error', {score, modality, e});
        return 0;
      }
    }

    const maxRangeToModalityFee = modalitiesFeesData?.length ? modalitiesFeesData.reduce((max, modality) => modality.rangeTo > max ? modality.rangeTo : max, 0) : null;

    const limiteAprovadoValue = limitValueOverwrite || limitsHandler.events.getLimiteAprovado({ questionnaire });

    setOutOfRangeError(Number(limiteAprovadoValue) > maxRangeToModalityFee);
    
    if (limiteAprovadoValue == null) return;

    const qstScoreSerasaValue = questionnaire.find(v => v.idQuestion === 1676)?.answer;

    const modalitiesGroup = [];
    let questionModality = [];

    const modalitiesFees = groupBy(modalitiesFeesData);
    if (questionnaireAnswersToDelete) {
      for (const modalityGroupQuestion of modalities) {
        questionnaireAnswersToDelete =
          [
            ...questionnaireAnswersToDelete,
            ...modalityGroupQuestion.filter(q => q.idQuestionnaireAnswers).map(q => q.idQuestionnaireAnswers)
          ].filter(v => v)
      }
      setQuestionnaireAnswersToDelete && setQuestionnaireAnswersToDelete(questionnaireAnswersToDelete);
    }


    modalitiesFees.map((mType) => {
      mType.items.map((mModality) => {
        questionModality = [];

        const feesModality = mModality.items.find((mdtItem) => {
          return mdtItem.rangeFrom <= limiteAprovadoValue && mdtItem.rangeTo >= limiteAprovadoValue;
        });
        const sublimitValue = (feesModality?.reductionRate || 0) * limiteAprovadoValue;
        (modalities?.length > 0 ? modalities[0] : []).map((qst) => {
          qst = cloneDeep(qst);
          qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}${uniqueId()}_${uniqueId()}`;
          qst.idQuestionnaireAnswers = null;
          qst.idQuestionnaireAnswersParent = null;
          qst.idQuestionnaireAnswersRoot = null;
          qst.answer = null;
          qst.idAnswerOption = null;

          if (qst.idQuestion === 1736) {
            qst.visibleQuestion = false;
            qst.answer = mType.name;
            delete (qst.mainGroup)
            if (!modalitiesGroup.find(modalityGroup => modalityGroup.find(qst => qst.idQuestion === 1736 && qst.answer === mType.name)))
              qst.mainGroup = true;
          }

          if (qst.idQuestion === 1689) {
            qst.visibleQuestion = false;
            qst.answer = mModality.name;
          }

          if (qst.idQuestion === 1690) {
            qst.answer = sublimitValue;
            qst.fieldMask.max = limiteAprovadoValue;
          }

          if (qst.idQuestion === 1691) {
            if (feesModality?.standardMaxLimClaim === 0) {
              qst.answer = sublimitValue;
            } else {
              if (mModality.name.includes('Depósito Recursal')) {
                qst.answer = (feesModality?.standardMaxLimClaim || 0);
                qst.disabled = true;
              } else {
                if (mModality.name.includes('Licitante') && sublimitValue > 100000) {
                  qst.answer = sublimitValue / 2;
                } else if (mModality.name.includes('Licitante')) {
                  qst.answer = sublimitValue;
                } else if (mModality.name.includes('Executante') && sublimitValue > 500000) {
                  qst.answer = sublimitValue / 2;
                } else if (mModality.name.includes('Executante')) {
                  qst.answer = sublimitValue;
                } else {
                  qst.answer = (feesModality?.standardMaxLimClaim || 0);
                }
              }
            }
          }

          if (qst.idQuestion === 1734) {
            qst.answer = (feesModality?.acceptanceRate || 0) * sublimitValue;
          }

          if (qst.idQuestion === 1692) {
            qst.answer = getScoreFeeByModality(
              scoreInformationData,
              qstScoreSerasaValue,
              mModality.name.includes('Judicial Depósito Recursal') ? 'Judicial Depósito Recursal' : mModality.name)
          }

          if (qst.idQuestion === 1693) {
            qst.answer = (feesModality?.minimumPremium || 0);
          }

          if (mModality.name.includes('Cobertura Adicional – Despesas de contenção e salvamento')) {
            qst.visibleQuestion = false;
            qst.hideModality = true;
          }

          if (qst.key) setFieldValue(qst.key, String(qst.answer));
          questionModality.push({ ...qst })
        })

        modalitiesGroup.push(questionModality)
      })
    });
    setModalities(modalitiesGroup)
  } catch (e) {
    console.log('handleModalities error', e)
  }
}

const groupBy = array =>
  array.reduce((groups, obj) => {
    const typeValue = ["type"].map(key => obj[key]).join('-');
    const modalityValue = obj["modality"];

    let typeGroup = groups.find(g => g.name.trim() === typeValue.trim());

    if (!typeGroup) {
      typeGroup = { name: typeValue, items: [] };
      groups.push(typeGroup);
    }

    let modalityGroup = typeGroup.items.find(g => g.name.trim() === modalityValue.trim());

    if (!modalityGroup) {
      modalityGroup = { name: modalityValue, items: [] };
      typeGroup.items.push(modalityGroup);
    }

    modalityGroup.items.push(obj);

    return groups;
  }, []);

const events = {
  handleInitialAdjustments,
  handleModalities,
}

export { events };
